import script from "./LottieLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./LottieLoader.vue?vue&type=script&setup=true&lang=js"

import "./LottieLoader.vue?vue&type=style&index=0&id=73e7e0fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73e7e0fa"]])

export default __exports__